import React from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const statusConfig = [
  {
    status: "Operational",
    bgColor: "bg-success/10",
    textColor: "text-statsGreen",
    borderColor: "border-success",
    icon: CheckCircleOutlineIcon,
  },
  {
    status: "Partial Issues",
    bgColor: "bg-statsOrange/10",
    textColor: "text-statsOrange",
    borderColor: "border-statsOrange",
    icon: WarningAmberIcon,
  },
  {
    status: "Experiencing Delays",
    bgColor: "bg-orange/10",
    textColor: "text-orange",
    borderColor: "border-orange",
    icon: AccessTimeIcon,
  },
  {
    status: "Down",
    bgColor: "bg-statsRed/10",
    textColor: "text-statsRed",
    borderColor: "border-statsRed",
    icon: ErrorOutlineIcon,
  },
];

const StatusCards = ({ services = [] }) => {
  const getStatusCount = (status) => {
    return services.filter(
      (service) => service.status.toLowerCase() === status.toLowerCase()
    ).length;
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 my-6">
      {statusConfig.map((config, index) => {
        const count = getStatusCount(config.status);
        const IconComponent = config.icon;
        return (
          <div
            key={index}
            className={`${config.bgColor} rounded-lg px-6 sm:px-9 py-9 border flex flex-col justify-between ${config.borderColor}`}
          >
            <div className="flex items-start justify-between mb-4">
              <h2 className={`text-xl md:text-2xl font-bold ${config.textColor}`}>
                {config.status}
              </h2>
              <div className={`${config.textColor}`}>
                <IconComponent style={{ fontSize: "2rem" }} />
              </div>
            </div>
            <p className={`pt-2 font-bold border-t ${config.borderColor} border-dashed ${config.textColor}`}>
              {count} {count === 1 ? "Service" : "Services"}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default StatusCards;
